var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",on:{"click":_vm.toSearch}},[_c('div',{staticClass:"img",attrs:{"alt":"","srcset":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }